import type { SxStyle } from '@aibees/shared/theme';

export const action: SxStyle = {
  justifyContent: 'space-between',
  border: 'none',
  padding: 0,
  paddingTop: 0.5,
};
